<script lang="ts" setup>
const { t } = useI18n()
const userStore = useUserStore()
const teamStore = useTeamsStore()
</script>

<template>
  <UCard
    v-if="!userStore.user"
    class="not-prose relative overflow-hidden"
    :ui="{ base: '!p-0', body: { padding: 'p-0' } }"
  >
    <BaseMask
      class="absolute inset-0 z-0 opacity-60 dark:opacity-100"
      image="search"
    />

    <div class="z-10 flex size-full flex-col items-center justify-center gap-4 text-center lg:flex-row lg:justify-between lg:text-left">
      <div class="relative flex w-full flex-col gap-2 p-4 lg:w-2/3">
        <h3 class="text-lg font-semibold leading-tight">
          {{ t('signup.title') }}
        </h3>

        <p class="text-sm text-gray-600 dark:text-gray-400">
          {{ t('signup.description') }}
        </p>
      </div>

      <div class="mb-8 flex w-full items-center justify-center md:mb-4 lg:w-1/3 lg:justify-end lg:pb-0">
        <SectionGetStartedButtons
          class="z-20"
          :show-book-demo="false"
        />
      </div>
    </div>
  </UCard>

  <UCard
    v-else-if="!teamStore.currentTeam?.stripeSubscribed"
    class="not-prose relative overflow-hidden"
    :ui="{ base: '!p-0', body: { padding: 'p-0' } }"
  >
    <BaseMask
      class="absolute inset-0 z-0 opacity-50 dark:opacity-100"
      image="search"
    />

    <div class="z-10 flex size-full flex-col items-center justify-center gap-4 p-6 text-center lg:flex-row lg:justify-between lg:text-left">
      <div class="relative flex w-full flex-col gap-2 lg:w-2/3">
        <h3 class="text-lg font-semibold leading-tight">
          {{ t('subscription.title') }}
        </h3>

        <p class="text-sm text-gray-600 dark:text-gray-400">
          {{ t('subscription.description') }}
        </p>
      </div>

      <div class="flex w-full items-center justify-center md:mb-4 lg:w-1/3 lg:justify-end">
        <SectionGetStartedButtons
          class="z-20"
          :show-book-demo="false"
          :show-get-started="false"
          show-subscribe
        />
      </div>
    </div>
  </UCard>
</template>

<i18n lang="json">
{
  "en": {
    "signup": {
      "description": "Get your 500 free credits and start enriching and searching companies.",
      "title": "Signup to access all our API features"
    },
    "subscription": {
      "description": "Get up to 500K credits per month by subscribing to one of our plans.",
      "title": "Choose your subscription plan"
    }
  },
  "es": {
    "signup": {
      "description": "Obtén tus 500 créditos gratuitos y comienza a enriquecer y buscar empresas.",
      "title": "Regístrate para acceder a todas las características de nuestra API"
    },
    "subscription": {
      "description": "Obtén hasta 500K créditos al mes suscribiéndote a uno de nuestros planes.",
      "title": "Elige tu plan de suscripción"
    }
  },
  "fr": {
    "signup": {
      "description": "Recevez vos 500 crédits gratuits et commencez à enrichir et rechercher des entreprises.",
      "title": "Inscrivez-vous pour accéder à toutes les fonctionnalités de notre API"
    },
    "subscription": {
      "description": "Obtenez jusqu'à 500 000 crédits par mois en vous abonnant à l’un de nos forfaits.",
      "title": "Choisissez votre plan d'abonnement"
    }
  }
}
</i18n>
